import { Button as AntButton, Modal } from "antd";
import { FC } from "react";
import { useTranslation } from 'react-i18next';

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
}

const ShowRublic5Modal: FC<IProps> = ({
  visible,
  setVisible,
}) => {
  const { t } = useTranslation();
  return (
    <Modal
      title="Rubric 5 Guide"
      visible={visible}
      width={750}
      onCancel={() => setVisible(false)}
      footer={[
        <div className='comm-btn__area justify-content-center'>
          <AntButton key="cancel" className='btn-basic gray' onClick={() => setVisible(false)}>
            {t('common.button.close')}
          </AntButton>
        </div>
      ]}
    >
      <table className="table table-bordered">
        <tbody>
          <tr>
            <th className="text-center align-middle font-weight-bold">Rubric 5</th>
            <td className="text-center align-middle">All Subjects</td>
            <td className="text-center align-middle">All Levels</td>
            <td className="text-center align-middle">
              Overall Participation
            </td>
            <td>
              - Participation
            </td>
          </tr>
        </tbody>
      </table>

      <table className="table table-bordered">
        <tr>
          <td />
          <th className="text-center font-weight-bold">Needs Improvement<br />1</th>
          <th className="text-center font-weight-bold">Fair<br />2</th>
          <th className="text-center font-weight-bold">Good<br />3</th>
          <th className="text-center font-weight-bold">Great<br />4</th>
          <th className="text-center font-weight-bold">Excellent<br />5</th>
        </tr>
        <tr>
          <th className="align-middle font-weight-bold">Participation</th>
          <td>The student’s participation is minimal. The student needs to be continuously coerced or prompted to participate.</td>
          <td>The student participates in the classroom activity with a little prompting from the teacher.</td>
          <td>The student participates in the classroom somewhat actively.</td>
          <td>The student participates in the classroom actively.</td>
          <td>The student participates in the classroom very actively. No coercion or prompting is needed.</td>
        </tr>
      </table>
    </Modal>
  );
}

export default ShowRublic5Modal;